import React, { useEffect } from 'react'
import CsvDownload from './CsvDownload';
import { CloseIcon, DeleteIcon, EditIcon, PlusIcon, UploadIcon } from "../../iconshere";
import { useState } from 'react';
import { ContentState, Editor, EditorState } from 'draft-js';
import { Dropdown, Modal } from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import rocket from '../../assets/img/rocket.gif';
import { useSelector } from 'react-redux';
import axios from 'axios';
import swal from 'sweetalert';
import htmlToDraft from 'html-to-draftjs';
import DraftEditor from './DraftEditor'
import CreateTaskModal from './CreateTaskModal';
import {useLocation} from "react-router-dom";
import CreateSubTaskModal from './CreateSubTask';
import EditTaskModel from './EditTaskModel';
import Swal from 'sweetalert2';

function VersionList({ v_id, w_id }) {

    const idData = { v_id, w_id };
    console.log("idData idData")
    console.log(idData)

    const [state, setState] = useState({
        isOpen: false,
        uploadImg: false,
        message: "",
        task_id: "",
        subtask_id: "",
        view_mode: "NULL", //TASK ,  SUBTASK,  IMAGE, VIDEO,
        taskList: [],
        files: [],
        files2: [],
        selectedTaskData: [],
        preImageTaskData: [],
        selectedSubTaskData: [],
        selectedTaskImage: [],
        selectedTaskVideo: [],
        selectedSubTaskImage: [],
        selectedSubtaskVideo: [],
        selectedSubTaskVideo_1: [],
        heading_text: "",
        heading_text_length: 0,
        heading_description: "",
        heading_description_length: 0,
        subtask_heading_text: "",
        subtask_heading_text_length: 0,
        subtask_heading_description: "",
        subtask_heading_description_length: 0,
        progress: "",
        buttonValue: false,
        viewMore: "",
        qr_code: "",
        version_status: null,
        is_completed_mode: null, // 'TRUE' 'FALSE'
        loading: false,
        taskGridView: false,
        darkMode: null,
        total: null,
        subTask_Delete: false,
        task_Delete: false,
        heading_textError: "",
        taskChar_Length: 0,
        subChar_Length: 0,
        subTaskImage: null,
        CSVtask_id: [],
        csvfile: [],
        csv_12: [],
        task_id1: '',
        task_EditorState: EditorState.createEmpty(),
        subTask_EditorState: EditorState.createEmpty(),
        verifyCSV: false,
        imageLength: 0,
        deleteTaskId: null,
        deleteTaskConfirm: false,
        taskId: null,
        taskType: null,
    });

    const [show, setShow] = useState(false);

    const [showCreateTask, setShowCreateTask] = useState(false);

    const[showsubTask,setSubtask]=useState(false);

    const[editTaskData,SetEditTaskData]=useState([]);

    const[showEditTask,setShowEditTask]=useState(false)
 
    const [refresh, setRefresh] = useState(0);
      
  const [workflowSTasktate, setWorkflowTaskState] = useState({
    workflowId: '',
    headingText: '',
    versionId: '',
    taskId:"",
    rawContentState: '',
    selectedImages: [],
    selectedVideos: [],
  });


    const userData = useSelector((state) => state.userSlice);

    const configData = useSelector((state) => state.configSlice);

    var { apiBaseUrl } = configData.config;

    const { token } = userData;

    const location = useLocation();

    const { locationState } = location;


    const headers = {
        'Authorization': `Bearer ${token}`
    }
   

    const getTaskList = async() => {

        var data = {
            workflow_id: idData.w_id,
            version_id: idData.v_id,
        };
        
      await axios.post(`${apiBaseUrl}/api/workflow/tasks`, data, {
            headers: headers,
        })
            .then(function (response) {
                if (response.status === 200) {
                    console.log(response.data)
                  
                    let matchingWorkflow = [];

                    console.log("mathccccccccccccc")
                    console.log( matchingWorkflow)

                    response.data.WorkFlows.forEach(workflow => {
                        let workflowId = workflow._id;
                    
                        // Find matching SubTask entries based on workflowId
                        let matchingSubTasks = response.data.SubTask.filter(subTask => subTask.task_id === workflowId);
                    
                        // If matching SubTask entries are found, push them to matchingWorkflow array
                        if (matchingSubTasks.length > 0) {
                            workflow.subTasks = matchingSubTasks;
                            matchingWorkflow.push(workflow);
                        } else {
                            // If no matching SubTask entries are found, set subTasks to an empty array
                            workflow.subTasks = [];
                            matchingWorkflow.push(workflow);
                        }
                    });

                    console.log("matchingWorkflow");
                    console.log(matchingWorkflow);

                        setState({
                            ...state,
                            taskList: matchingWorkflow,
                            message: "No Record Found.",
                        })
                   
                 
                    
                }
            })
            .catch(function (err) {
          
                console.log(err);
            });
    };

    const selectedTask = () => {
        let current = this;
    
        if (state.task_id !== "") {
          let selectedTaskData = state.taskList.find((x) => x._id === state.task_id);
    
          //Task Description Convert HTML To Draft.js start
            const blocksFromHtml = htmlToDraft(selectedTaskData?.task_description); 
            const { contentBlocks, entityMap } = blocksFromHtml;
            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
            const editorState = EditorState.createWithContent(contentState);
          //Task Description Convert HTML To Draft.js end
    
           setState({
            ...state,
            view_mode: "TASK",
            selectedTaskData: selectedTaskData,
            selectedTaskImagePath:selectedTaskData?.image_collection,
            heading_text: selectedTaskData?.heading_text, 
            heading_text_length: 50-parseInt(selectedTaskData?.heading_text.length),
            heading_description: selectedTaskData?.task_description,
            task_EditorState: editorState, 
            heading_description_length: 150-parseInt(editorState.getCurrentContent().getPlainText('').length),
          });
          // if(this.state.subtask_id!=='' && (this.state.view_mode=="TASK" || this.state.view_mode==="SUBTASK")){
          if (state.subtask_id !== "" && state.view_mode !== "NULL") {
            let selectedSubTaskData = selectedTaskData?.subtasks.find(
              (x) => x._id === state.subtask_id
            );
    
            //Sub_Task Description Convert HTML To Draft.js start
            const blocksFromHtml = htmlToDraft(selectedSubTaskData?.subTask_description); 
            const { contentBlocks, entityMap } = blocksFromHtml;
            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
            const editorState = EditorState.createWithContent(contentState);
          //Sub_Task Description Convert HTML To Draft.js end
    
    
            current.setState({
              view_mode: "SUBTASK",
              selectedSubTaskData: selectedSubTaskData,
              subtask_heading_text: selectedSubTaskData?.heading_text, 
              subtask_heading_text_length: 50-parseInt(selectedSubTaskData?.heading_text.length),
              subtask_heading_description: selectedSubTaskData?.subTask_description,
              subTask_EditorState: editorState, 
              // subtask_heading_description_length: 150-parseInt(selectedSubTaskData?.description.length),
              subtask_heading_description_length: 150-parseInt(editorState.getCurrentContent().getPlainText('').length),
            
            });
          }
        }
      };

 const updateWorkflowStatus=async(e)=>{
    var data = {
        workflow_id: idData.w_id,
        version_id: idData.v_id,
        status:true
    };
  await axios.post(`${apiBaseUrl}/api/workflow/live`, data, {
        headers: headers,
    })
        .then(function (response) {
            if (response.status === 200) {
                console.log(response.data)
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "WorkFlow Published",
                    showConfirmButton: false,
                    timer: 1500
                  });
              
            }
        })
        .catch(function (err) {
      
            console.log(err);
        });
    
 }

 const editTask=async(item)=>{
    SetEditTaskData(item);
    setShowEditTask(true);
 }

     const openCSVFile = () => setState({isOpen: true });

      const handleCreateTask = () => {
        setShow(true);
        setState((prevState) => ({
            ...prevState,
            view_mode: "TASK",
          }));
      };

      const handleShow=()=>{
        setShow(true)
      }
    
    useEffect(() => {
        getTaskList();
        selectedTask();
        setState({
            ...state, CSVtask_id: null
        })
    }, []);

    let imgLength={
        imgL:0
    };
    
    let videoLength={
      videoL:0
    };

    const countSubtaskImage = async(data)=>{

        console.log(data)

        imgLength.imgL=0;
         var b=0;
         for(var t=0;t<data?.length;t++){
           b=b+data[t].image_collection.length;
         } 
         imgLength.imgL=b;
           return

     }


     const handleDeleteTask = async (id) => {

        var data = {
          Task_id: id,
        };
      
        try {
          const response = await axios.post(`${apiBaseUrl}/api/workflow/deletetask`, data, {
            headers: headers,
          });
      
          if (response.status === 200) {
            console.log(response.data)
            getTaskList()
            setWorkflowTaskState({
                workflowId: '',
                headingText: '',
                versionId: '',
                taskId: '',
                rawContentState: '',
                selectedImages: [],
                selectedVideos: [],
              });
            swal("Task Deleted Succesfully")
          }
        } catch (err) {
    
          console.error(err);
        }
      };

    const countSubtaskVideo = async(data)=>{

        console.log(data)

        videoLength.videoL=0;
         var a=0;
         for(var m=0;m<data?.length;m++){
           a=a+data[m].video_collection.length;
         } 
         videoLength.videoL=a;
         return
     }

     useEffect(() => {
        getTaskList();
      }, [showsubTask]);

    return (
        <>
                <div className="page-content">

                    <div className="card-header">
                        <div className="row align-items-center">
                            <div className="col-2">
                                <h4 className="mb-sm-0 font-size-18" style={{ color: "#333" }}>{location?.state}</h4>
                            </div>

                            <div className="col-10 text-md-right d-flex align-items-center justify-content-end">

                                {/* Check task published or not */}

                                {/* if Task not publishded */}
                                {(
                                    <>
                                        {/* CSV File Section start */}
                                        {/* <span>
                                            <label style={{ marginBottom: '0px' }}>
                                               
                                            </label>

                                            <label className="ms-3" style={{ marginBottom: '0px' }}>
                                                <span className=" btn btn-sm csvdownload" onClick={openCSVFile}>
                                                    <div className="svg">
                                                        
                                                    </div>
                                                    <div>CSV</div>
                                                </span>
                                            </label>


                                        </span> */}
                                        {/* CSV File Section end */}


                                        <button className="ms-3 redbtn btn btn-sm" style={{ fontWeight: "500 !important", height: "40px" }} onClick={handleCreateTask}>
                                            <PlusIcon />Create Task
                                        </button>


                                        <button
                                            className="ms-3 btn btn-sm redbgbtn mb-0"
                                            onClick={() => updateWorkflowStatus(true)}
                                            style={{ fontWeight: "500 !important", height: "40px" }}
                                            disabled={state.taskList?.length === 0}
                                        >
                                            Publish Workflow
                                        </button>

                                        {/* Grid Icon Start */}

                                        {/* <div className="gridIcon">
                                      { state.taskGridView===true ?( 
                                        state.darkMode===true ?
                                          <i className="fa fa-bars" onClick={this.changeView} style={{color:'white', fontSize:'22px',marginRight:'20px'}}></i>
                                          :
                                        <i className="fa fa-bars" onClick={this.changeView} style={{color:'black', fontSize:'22px',marginRight:'20px'}}></i>
                                      ):(
                                      state.darkMode===true ?
                                      <i className="fa fa-th" onClick={this.changeView} style={{color:'white', fontSize:'22px',marginRight:'20px'}}></i>
                                      :
                                      <i className="fa fa-th" onClick={this.changeView} style={{color:'black', fontSize:'22px',marginRight:'20px'}}></i>
                                          )
                                      }
                                    </div> */}
                                        {/* Grid Icon End */}

                                    </>
                                )}

                                {/* if Task publishded */}
                           


                            </div>
                        </div>
                    </div>


                    <div className="row mt-4">

            


                        {/* All Task Start */}
                        {state.taskGridView===true ?
                            <>
                                {/* {state.taskList?.map((list, index) => (
                                    <div className="col-md-3" style={{ top: "15px", marginBottom: "15px" }} >
                                        <div className="cbox versionbox">
                                            <div>
                                                <h3>{list.heading_text}</h3>
                                            </div>
                                            <div className="buttons">
                                                <button className="btn btn-sm btn-primary" onClick={() => this.editTask(list._id)} >
                                                    <i className="fa fa-edit"></i> Edit
                                                </button>
                                                <button className="btn btn-sm btn-danger" onClick={() => this.onDelete(list._id, 1)} >
                                                    <i className="bx bx-trash"></i> Delete
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))} */}
                            </>
                            :
                            <>
                                <div className="table-responsive workflowtb">
                                    <table className="table align-middle table-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ textAlign: 'center' }}>S.No</th>
                                                <th style={{ textAlign: 'center' }}>Task Name</th>
                                                <th style={{ textAlign: 'center' }}>Task Image</th>
                                                <th style={{ textAlign: 'center' }}>Task video</th>
                                                <th style={{ textAlign: 'center' }}>Subtask </th>
                                                <th style={{ textAlign: 'center' }}>Subtask Image</th>
                                                <th style={{ textAlign: 'center' }}>Subtask Video</th>
                                                <th style={{ textAlign: 'center' }}>Action</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {state.taskList?.map((list, index) =>

                                                <tr>
                                                    <td style={{ textAlign: 'center' }}> {index + 1} </td>
                                                    <td style={{ textAlign: 'center' }}> {list.heading_text} </td>
                                                    <td style={{ textAlign: 'center' }}> {list.image_collection.length} </td>
                                                    <td style={{ textAlign: 'center' }}> {list.video_collection.length} </td>
                                                    <td style={{ textAlign: 'center' }}> {list.subTasks.length} </td>
                                                    <td style={{ textAlign: 'center' }} {...countSubtaskImage(list.subTasks)} >  {imgLength.imgL}    </td>
                                                    <td style={{ textAlign: 'center' }} {...countSubtaskVideo(list.subTasks)} >  {videoLength.videoL}   </td>

                                                    <td className="align-middle text-center userdrop">

                                                        <Dropdown>
                                                            <Dropdown.Toggle id="dropdown-basic">
                                                                <div className="options">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                                                                        <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                                                                    </svg>
                                                                </div>
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu className="sidebartopbar modulelistoptions">
                                                                <div className="listoptionsmodule">
                                                                    {/* <p onClick={() => editTask(list)}>
                                                                        <EditIcon />
                                                                        Edit</p> */}
                                                                    <p onClick={()=>handleDeleteTask(list._id)}>
                                                                        <DeleteIcon />
                                                                        Delete</p>
                                                                </div>

                                                            </Dropdown.Menu>
                                                        </Dropdown>



                                                        {/* <div className="buttons d-flex justify-content-center">
                                                <button
                                                  className="btn btn-sm btn-outline-success wedit"
                                                  onClick={() => this.editTask(list._id)}
                                                >
                                                  <i className="fa fa-edit"></i> Edit
                                                </button>
                                      
                                              <button 
                                                  onClick={() => this.onDelete(list._id, 1)}
                                                  className="btn btn-sm btn-outline-danger"
                                                >
                                                  <i className="bx bx-trash"></i> Delete
                                                </button>
                                            </div> */}
                                                    </td>

                                                </tr>
                                            )}
                                        </tbody>

                                    </table>
                                </div>
                            </>
                        }
                        {/* All Task  end */}

                    </div>


                </div>

    <CreateTaskModal show={show} setShow={setShow}  v_id={v_id} w_id={ w_id} setSubtask={setSubtask} setWorkflowTaskState={setWorkflowTaskState} />

    <CreateSubTaskModal v_id={v_id} w_id={ w_id} setSubtask={setSubtask} showsubTask={showsubTask} taskId={workflowSTasktate.taskId} />

    <EditTaskModel v_id={v_id} w_id={ w_id} editTaskData={editTaskData} SetEditTaskData={SetEditTaskData} setShowEditTask={setShowEditTask} showEditTask={showEditTask}  />

            {/* Delete Task */}
            {/* <Modal centered show={state.deleteTaskConfirm} onHide={"this.cancelHandleDeleteTask"} >
                <Modal.Header className="popupheader delete pt-4">
                    Delete Task
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group pt-4 pb-5 m-0">
                                <p className="popupheading delete p-0 m-0">Do you really want to delete this Task?</p>
                            </div>
                            <div className="row">
                                <div className="col-12 d-flex justify-content-center mt-2 mb-2">

                                    <button className=" redbgbtn cancel" onClick={this.cancelHandleDeletetask}>Cancel</button>
                                    <button className="ms-3 redbgbtn" onClick={this.confirmHandleDeleteTask}>Delete</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal> */}

            {/* QR Code */}
            {/* <Modal centered show={state.qrOpen} size="sm" onHide={this.closeModalQR}>
          <Modal.Header className="popupheader">
                    Please Download QR CODE
                    <div style={{ cursor:"pointer" }} onClick={this.closeModalQR}>
                        <CloseIcon />
                    </div>
                </Modal.Header>
            <Modal.Body>
              <UrlImageDownloader
                imageUrl={`${apiBaseUrl}/${state.qr_code}`}
              />
            </Modal.Body>
          </Modal> */}

            {state.loading ? (
                <div className="rocket">
                    <img src={rocket} alt='' />
                </div>
            ) : null}

        </>
    );
}


export default VersionList